import HelpIcon from '@mui/icons-material/Help'
import BuildIcon from '@mui/icons-material/Build'
import SupportAgentIcon from '@mui/icons-material/SupportAgent'
import NewsIcon from '@mui/icons-material/Announcement'
import { HelpCenterCardsContainerContentTypeKey, HelpCenterCardsDef, HelpCenterClickHandler } from './_props'
import { text } from './_utils'
import { sxs } from './_sxs'
import HelpCenterCardSupportButton from './HelpCenterCardSupportButton'
import { constants } from '../../..'
import HelpCenterCardButtonClickable from './HelpCenterCardButtonClickable'

export const buildHelpCenterCards = (
    contentTypes: HelpCenterCardsContainerContentTypeKey[],
    onClick?: HelpCenterClickHandler
) => {
    const { helpCenterAndTutorials, supportContact, exchangeViews, newsFeed } = text.card

    const helpCenterCardsDef: Record<HelpCenterCardsContainerContentTypeKey, HelpCenterCardsDef> = {
        helpCenterAndTutorials: {
            id: 1,
            type: 'helpCenterAndTutorials',
            icon: <HelpIcon sx={[sxs.cardIconBase, sxs.cardFilledIcon]} />,
            title: helpCenterAndTutorials.title,
            description: helpCenterAndTutorials.description,
            url: helpCenterAndTutorials.url,
            buttonContent: <HelpCenterCardButtonClickable buttonName={helpCenterAndTutorials.buttonName} />,
        },
        supportContact: {
            id: 2,
            type: 'supportContact',
            icon: <BuildIcon sx={[sxs.cardIconBase, sxs.cardWhiteOnBlueIcon]} />,
            title: supportContact.title,
            description: supportContact.description,
            buttonContent: (
                <HelpCenterCardSupportButton
                    email={constants.SUPPORT_EMAIL}
                    onEmailClick={() => onClick?.('supportContact', 'email')}
                />
            ),
        },
        exchangeViews: {
            id: 3,
            type: 'exchangeViews',
            icon: <SupportAgentIcon sx={[sxs.cardIconBase, sxs.cardWhiteOnBlueIcon]} />,
            title: exchangeViews.title,
            description: exchangeViews.description,
            buttonContent: <HelpCenterCardSupportButton />,
        },
        newsFeed: {
            id: 4,
            type: 'newsFeed',
            icon: <NewsIcon sx={[sxs.cardIconBase]} />,
            title: newsFeed.title,
            description: newsFeed.description,
            buttonName: newsFeed.buttonName,
            url: newsFeed.url,
            colorVariant: 'secondary',
        },
    }

    const cards: HelpCenterCardsDef[] =
        contentTypes.length === 0
            ? Object.values(helpCenterCardsDef)
            : contentTypes.map((type) => helpCenterCardsDef[type])

    return cards
}
